import { DateTime } from 'luxon';
export const dateParser = date => {
  if (!date) {
    return new Date(NaN);
  }
  if (date instanceof Date) {
    return date;
  }
  try {
    const numDate = Number(date);
    if (Number.isNaN(numDate)) {
      throw new Error('Invalid date');
    }
    return new Date(numDate);
  } catch (e) {
    return new Date(date);
  }
};
export const convertToDateTimeByTimezone = (millis, timezone) => DateTime.fromMillis(millis, {
  zone: 'UTC'
}).setZone(timezone);
export const dateKeyFromDateTime = dateTime => `${dateTime.year}.${dateTime.month}.${dateTime.day}`;
export const dateKeyFromDate = date => {
  return `${date.getFullYear()}.${date.getMonth() + 1}.${date.getDate()}`;
};
export const dateTimeToTimeString = dateTime => dateTime.toLocaleString(DateTime.TIME_SIMPLE);
//# sourceMappingURL=dateTimeUtils.js.map